// extracted by mini-css-extract-plugin
export default {"metadata-table":"MetadataTable__metadata-table___RXYES"};